// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--fM21l","icon":"a10a3f92e9--icon--TTGvi"};